<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Batch E-Coupons Reminder</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <form @submit.prevent="save">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="form-group row align-items-center">
                <label class="col-md-4 fit-content">Minimum batch e-coupons to remind</label>
                <div class="col-md-1 pl-0">
                  <input
                    type="number"
                    v-model="reminder"
                    class="form-control"
                    required
                  />
                </div>
                <div
                  class="col-md-1">
                  <button type="submit" class="btn btn-primary">Save</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
export default {
  data() {
    return {
      reminder: 0,
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("emstoken"));
      return data;
    },
    config() {
      return { headers: { Authorization: `Bearer ${this.tokenObj.token}` } };
    },
  },
  methods: {
    save() {
      let param = {
        key: config.SETTING_KEY_MIN_BATCH_ECOUPON_REMINDER,
        value: this.reminder
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to update the minimum batch e-coupons to remind?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.saveSetting(param, this.config)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              console.log(error);
            });
        }
      });
    },
    getMinimumBatchEcouponReminder() {
      let param = {
        key: config.SETTING_KEY_MIN_BATCH_ECOUPON_REMINDER
      };
      this.$store.state.isLoading = true;
      API.getSetting(param, this.config)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.reminder = response.data.value;
          } else {
            // this.$swal(response.data.message, { icon: "error" });
            this.reminder = 0;
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
  },
  created() {
    this.getMinimumBatchEcouponReminder();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Share/BatchEcouponReminder.vue